import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InlineToolbarButton, FORMATTING_BUTTONS } from 'wix-rich-content-editor-common';
import SpoilerButtonIcon from '../../Icons/SpoilerButtonIcon.js';
import { SPOILER_TYPE } from 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class BlockSpoilerButton extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "handleClick", (event) => {
      event.preventDefault();
      this.toggleSpoiler();
    });
    __publicField(this, "toggleSpoiler", () => {
      var _a;
      const { pubsub } = this.props;
      const { spoiler = {} } = (_a = this.props.pubsub.get("componentData")) == null ? void 0 : _a.config;
      pubsub.setBlockData({
        key: "componentSpoiler",
        item: __spreadProps(__spreadValues({}, spoiler), { enabled: !this.isActive })
      });
    });
  }
  get isActive() {
    var _a, _b;
    const componentData = this.props.pubsub.get("componentData");
    return !!((_b = (_a = componentData == null ? void 0 : componentData.config) == null ? void 0 : _a.spoiler) == null ? void 0 : _b.enabled);
  }
  render() {
    const { theme, helpers, isMobile, tabIndex, tooltipText } = this.props;
    return /* @__PURE__ */ React.createElement(
      InlineToolbarButton,
      {
        onClick: this.handleClick,
        isActive: this.isActive,
        helpers,
        dataHook: "spoilerButton",
        formattingButtonName: FORMATTING_BUTTONS.SPOILER,
        theme,
        isMobile,
        tooltipText,
        tabIndex,
        icon: SpoilerButtonIcon,
        pluginType: SPOILER_TYPE
      }
    );
  }
}
BlockSpoilerButton.propTypes = {
  pubsub: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  helpers: PropTypes.object,
  isMobile: PropTypes.bool,
  tabIndex: PropTypes.number,
  tooltipText: PropTypes.string
};

export { BlockSpoilerButton as default };
//# sourceMappingURL=BlockSpoilerButton.js.map
